module.exports = function() {
  return new Worker(__webpack_public_path__ + "13e8da3b58a817007d03.worker.js");
};